import React, { useState, useRef } from 'react';
import './Contact.css';
import { globals } from "../globals";

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '', website: '' });
  const [status, setStatus] = useState('');
  const startedAt = useRef(Date.now()); // quando il modulo è stato mostrato

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Inviando...');

    try {
      const response = await fetch(`${globals.homepageUrl}/php/contact.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, elapsed: Date.now() - startedAt.current }),
      });
      const result = await response.json();

      if (result.success) {
        setStatus('Messaggio inviato con successo!');
        setFormData({ name: '', email: '', message: '', website: '' });
        startedAt.current = Date.now();
      } else {
        setStatus(result.error || 'Errore nell\'invio, riprova.');
      }
    } catch (error) {
      setStatus('Errore di connessione.');
    }
  };

  return (
    <div className="contact-container">
      <h1>Contattaci</h1>
      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          name="name"
          placeholder="Il tuo nome"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="La tua email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Il tuo messaggio"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>

        {/* Honeypot: nascosto agli utenti, i bot lo compilano */}
        <input
          type="text"
          name="website"
          value={formData.website}
          onChange={handleChange}
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0 }}
        />

        <button type="submit">Invia</button>
      </form>
      {status && <p className="contact-status">{status}</p>}
    </div>
  );
}